import { Helmet } from 'react-helmet-async';
import Header from '../GlobalComponents/Funtion-Header/Header';
import TableView from '../GlobalComponents/TableView/TableView';
import apiMiddleware from '../Utility/middleware';
import React, { useEffect, useState } from 'react';
import Loader from '../GlobalComponents/Loader/Loader';
import ExcelDownload from '../GlobalComponents/Download/ExelDownload';
import MaintenancePopup from "../GlobalComponents/Shedule-Maintanc/MaintannacePoup";
import { format } from 'date-fns';
import Alert from "../GlobalComponents/Shedule-Maintanc/AlertPopUP";
import PDFDownload from '../GlobalComponents/Download/PDFDownload';
import schedulePingRequest from '../Utility/Sheduler';
import axios from 'axios';
import { IoEye } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { SiStatuspal } from "react-icons/si";
import DevicesGet from '../Utility/DevicesGet';
import ConfirmDialog from'../GlobalComponents/Alert/ConfirmDailog';



const PDUheader = [

  //   {
  //     key: 'View',
  //     label: <IoEye size={25}/>,
  //     render: (row) => (
  //         <Link to={`/maintenance-schedules/${row.ip_address}`}>
  //          <IoEye size={25}/>
  //          <p className=' hidden'>{row.ip_address}</p>
  //          </Link>
  //     ),
  // },
  {
    key: 'health',
    label: <SiStatuspal size={25} />,
    render: (row) => (
      <span
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${row.health.overall === 'Good' ? 'bg-green-500' :
          row.health.overall === 'Critical' ? 'bg-red-500' :
            row.health.overall === 'Warning' ? 'bg-yellow-500' : 'bg-gray-500'
          } text-white`}

        title={`${row.health.overall} || ${row.health.connectivity_explanation}`}
      >
        <p className={`hidden`}>
          {row.health.overall}
        </p>
      </span>
    ),
  },
  { key: 'ip_address', label: 'IP Address' },
  { key: 'firmware_version', label: 'Firmware Version' },
  { key: 'Firmware', label: 'Latest Firmware' },
  {
    key: "version",
    label: "Update Required",
    render: (row) => {
      const compareFirmwareVersions = (currentVersion, latestVersion) => {
        if (latestVersion === "") return "Unknown"; // Handle missing data
  
        const parseVersion = (version) => {
          // Extract numeric parts from the version string
          let cleanVersion = version.match(/[\d.]+/g); // Match sequences of digits and dots
          if (!cleanVersion) return []; // Return empty array if no match found
          return cleanVersion[0].split('.').map((num) => parseInt(num, 10) || 0); // Split by dot and convert to integers
        };
  
        const currentParts = parseVersion(currentVersion);
        const latestParts = parseVersion(latestVersion);
  
        for (let i = 0; i < Math.max(currentParts.length, latestParts.length); i++) {
          const curr = currentParts[i] || 0;
          const latest = latestParts[i] || 0;
  
          if (curr < latest) return "Update Needed";
          if (curr > latest) return "Up-to-date";
        }
  
        return "Up-to-date";
      };
  
      return (
        <span
          className={`px-2 py-1 rounded text-white ${
            compareFirmwareVersions(row.firmware_version, row.Firmware) === "Update Needed"
              ? "bg-red-500"
              : compareFirmwareVersions(row.firmware_version, row.Firmware) === "Unknown"
              ? "bg-yellow-500"
              : "bg-green-500"
          }`}
        >
          {compareFirmwareVersions(row.firmware_version, row.Firmware)}
        </span>
      );
    },
  },
  { key: 'model', label: 'Model Name' },

  {
    key: 'location', label: 'Device Location'

  },
  { key: 'description', label: 'Description' },
  { key: 'manufacturer', label: 'Manufacturer' },
  { key: 'caption', label: 'Room Name' },


]


const AVheader = [
  //   {
  //     key: 'View',
  //     label: <IoEye size={25}/>,
  //     render: (row) => (
  //         <Link to={`/maintenance-schedules/${row.NetworkSettings.IPAddress}`}>
  //          <IoEye size={25}/>
  //          <p className=' hidden'>{row.NetworkSettings.IPAddress}</p>
  //          </Link>
  //     ),
  // },
  {
    key: 'Status',
    label: <SiStatuspal size={25} />,
    render: (row) => {
      const statusClass =
        row.Status === 'Active' ? 'bg-green-500' :
          row.Status === 'Missing' ? 'bg-red-500' :
            'bg-gray-400'; // Default class if the status doesn't match any condition

      return (
        <span
          className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${statusClass} text-white`}
          title={row.Status}
        >
          <p className="hidden">
            {row.Status === 'Active' ? 'ONLINE' : 'OFFLINE'}
          </p>
        </span>
      );
    },
  },
  {
    key: 'NetworkSettings',
    label: 'IP Address',

    render: (row) => (
      <span className="">
        {row.NetworkSettings.IPAddress}
      </span>
    )
  },
  { key: 'FirmwareVersion', label: 'Firmware Version' },
  { key: 'Firmware', label: 'Latest Firmware' },
  {
    key: "version",
    label: "Update Required",
    render: (row) => {
      const compareFirmwareVersions = (currentVersion, latestVersion) => {
        if (latestVersion === "") return "Unknown"; // Handle missing data
  
        const parseVersion = (version) => {
          // Extract numeric parts from the version string, ignoring any suffixes
          let cleanVersion = version.match(/[\d]+/g); // Match sequences of digits
          if (!cleanVersion) return []; // Return empty array if no match found
          return cleanVersion.map((num) => parseInt(num, 10) || 0); // Convert to integers
        };
  
        const currentParts = parseVersion(currentVersion);
        const latestParts = parseVersion(latestVersion);
  
        for (let i = 0; i < Math.max(currentParts.length, latestParts.length); i++) {
          const curr = currentParts[i] || 0;
          const latest = latestParts[i] || 0;
  
          if (curr < latest) return "Update Needed";
          if (curr > latest) return "Up-to-date";
        }
  
        return "Up-to-date";
      };
  
      return (
        <span
          className={`px-2 py-1 rounded text-white ${
            compareFirmwareVersions(row.FirmwareVersion, row.Firmware) === "Update Needed"
              ? "bg-red-500"
              : compareFirmwareVersions(row.FirmwareVersion, row.Firmware) === "Unknown"
              ? "bg-yellow-500"
              : "bg-green-500"
          }`}
        >
          {compareFirmwareVersions(row.FirmwareVersion, row.Firmware)}
        </span>
      );
    },
  },
  {
    key: 'ControllerName', label: 'Controller Name'
  },
  {
    key: 'RoomId', label: 'Room ID'
  },
  {
    key: 'ControllerType', label: 'Controller Type'
  },
  {
    key: 'ModelName', label: 'Model Name'
  },


]








/// PDF and XEL EXPORT settings Headers

const AVPDFheader = [
  //   {
  //     key: 'View',
  //     label: <IoEye size={25}/>,
  //     render: (row) => (
  //         <Link to={`/maintenance-schedules/${row.NetworkSettings.IPAddress}`}>
  //          <IoEye size={25}/>
  //          <p className=' hidden'>{row.NetworkSettings.IPAddress}</p>
  //          </Link>
  //     ),
  // },
  {
    key: 'Status',
    label: 'Device Status'
  },
  {
    key: 'NetworkSettings.IPAddress',
    label: 'IP Address',
  },
  { key: 'FirmwareVersion', label: 'Firmware Version' },
  { key: 'Firmware', label: 'Latest Firmware' },
  {
    key: 'ControllerName', label: 'Controller Name'
  },
  {
    key: 'RoomId', label: 'Room ID'
  },
  {
    key: 'ControllerType', label: 'Controller Type'
  },
  {
    key: 'ModelName', label: 'Model Name'
  },


]


const PDUPDFheader = [

  //   {
  //     key: 'View',
  //     label: <IoEye size={25}/>,
  //     render: (row) => (
  //         <Link to={`/maintenance-schedules/${row.ip_address}`}>
  //          <IoEye size={25}/>
  //          <p className=' hidden'>{row.ip_address}</p>
  //          </Link>
  //     ),
  // },
  {
    key: 'health.overall',
    label: 'Health'
  },
  { key: 'ip_address', label: 'IP Address' },
  { key: 'firmware_version', label: 'Firmware Version' },
  { key: 'Firmware', label: 'Latest Firmware' },
  { key: 'model', label: 'Model' },

  { key: 'location', label: 'Device Location' },
  { key: 'description', label: 'Description' },
  { key: 'manufacturer', label: 'Manufacturer' },
  { key: 'caption', label: 'Room Name' },


]





const Devices = () => {
  const [Devices, setDevices] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selecteFilter, setSelecteFilter] = useState('av');
  const [isOpen, setIsOpen] = useState(false);
  const [SearchTerm, setSearchTerm] = useState('');

  const [loading, setLoading] = useState(false);

  const [Heading, setHeading] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [AlertData, setAlertData] = useState([]);

  useEffect(() => {




    setLoading(true)
   

    setLoading(true);
    handleCrudOperation();
    
  

   

    // setLoading(false);
  }, [])

  const handleCrudOperation = async () => {
    const body = {
      queryType: 'custom-query',
      table: 'FirmwareUpdate',
      data: {
        query: "SELECT * FROM FirmwareUpdate",
      }
    }

    const response = await apiMiddleware('POST', body);





    if (response.success) {
      setLoading(false)
      setDevices(response.data);
   
     
    } else {
      console.error('CRUD Operation Failed:', response.error);
    }
  };



  const [pduData, setPduData] = useState([]);
  const [avData, setAvData] = useState([]);
  const [smartSwitchData, setSmartSwitchData] = useState([]);




  console.log("PDU",pduData)
  // console.log("AV",avData)

  useEffect(() => {
  const fetchDevicesdata = async () => {
    setLoading(true)
    try {


      const AVdevice = await DevicesGet("/AV");

      // console.log(AVdevice)
      if (AVdevice.success === false) {
        console.error("Failed to fetch device data:", AVdevice.error);
        return;
      }


      const PDUevice = await DevicesGet("/PDU");

      if (PDUevice.success === false) {
        console.error("Failed to fetch device data:", PDUevice.error);
        return;
      }



      const mergedAVData = AVdevice.Controllers.map(controller => {
        const firmware = Devices.find(fw => fw.device_id === controller.ControllerId && fw.device_ip === controller?.NetworkSettings?.IPAddress);
      
        return {
          ...controller,
          Firmware: firmware ? firmware.Firmware : "",
        };
      });




      const mergedPDUData = PDUevice.pdus.map(pdu => {
        const firmware = Devices.find(fw => fw.device_id === pdu.id && fw.device_ip === pdu?.ip_address);
      
        return {
          ...pdu,
          Firmware: firmware ? firmware.Firmware : "",
        };
      });

  
      setPduData(mergedPDUData);
      setAvData(mergedAVData);

     

      // setSmartSwitchData(smartSwitchResponse.data);
    } catch (err) {
      console.error('Error fetching data:', err);
      // setError(err);
    } finally {
      setLoading(false);
    }
  };
  fetchDevicesdata();
  },[Devices]);













  const handleSearchChange = (Data) => {

    setSearchTerm(Data);
  };


  const handleonDeviceSelect = (selectedData) => {
    setSelecteFilter(selectedData);



  };



  const handleRowSelectionChange = (selectedData) => {
    setSelectedRows(selectedData);
  };


  const [ConfirmSavwe, setConfirmSavwe] = useState(false);


  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [Download, setDownload] = useState('');

  





  const handleDownload = () => {
    
    setIsDialogOpen(false)

      if (Download === 'excel') {
        // Check for the 'av' filter and call ExcelDownload
        if (selecteFilter === 'av') {
          ExcelDownload({ headers: AVPDFheader, rows: selectedRows, filename: 'av-data.xlsx' });
        }

        if (selecteFilter === 'pdu') {
          ExcelDownload({ headers: PDUPDFheader, rows: selectedRows, filename: 'PDU-data.xlsx' });
        }




      }

      if (Download === 'pdf') {

        if (selecteFilter === 'av') {
          PDFDownload({ headers: AVPDFheader, rows: selectedRows, Name: "AV Devices", filename: "AV_REport.pdf" })
        }

        if (selecteFilter === 'pdu') {
          PDFDownload({ headers: PDUPDFheader, rows: selectedRows, Name: "PDU Devices", filename: "PDU_report.pdf" })

        }


      }
    
    // Directly call the ExcelDownload function to trigger the download



  };


  const FunctionBTN = (btn) => {
    if (selectedRows.length <= 0) {

      setShowAlert(true);
      setAlertData([

        {
          type: 'hold',
          title: 'No Device Selected',
          message: 'Please select at least one device to download the file.'
        }
      ])

      return;
    }
    setDownload(btn);
    setIsDialogOpen(true)
  }




  const handleRunSelfDiagnostics = () => {
    setHeading('Self Diagnostics');
    setIsOpen(true)


  };

  const SheduledProcessDateTime = async (date, actionType) => {



    // First, install date-fns
    // npm install date-fns


    const formattedDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');








    if (actionType === 'run') {
      // const body = {
      //   "route": "http://localhost:3500/api/ping/batch",
      //   "headers": {

      //   },
      //   "body": {
      //     "ips": selectedRows.map((data) => data.HOST_IP),
      //     "numPings": 4
      //   },
      //   "run_at": formattedDate
      // }

      // ;

      // const response = await apiMiddleware('/scheduler/schedule', 'POST', body);

      // if (response.success) {

      //   console.log(response);
      //   setShowAlert(true);

      // } else {
      //   console.error('CRUD Operation Failed:', response.error);
      // }




      const ips = selectedRows.map((data) => data.HOST_IP);

      // Call the middleware function with the IPs and runAt time
      schedulePingRequest(ips, formattedDate)
        .then(data => {


          setAlertData([

            {
              type: 'success',
              title: 'Hurray! Maintenance Started!',
              message: 'Maintenance Run Task Added'
            }
          ])


          setShowAlert(true);
        })
        .catch(error => {
          console.error(error.message);
          alert('Failed to schedule ping request');
        });





    }
    else if (actionType === 'schedule') {

      const ips = selectedRows.map((data) => data.HOST_IP);

      // Call the middleware function with the IPs and runAt time
      schedulePingRequest(ips, date)
        .then(data => {


          setAlertData([

            {
              type: 'success',
              title: 'Hurray! Maintenance scheduled!',
              message: 'Maintenance Will Run on ' + date
            }
          ])


          setShowAlert(true);
        })
        .catch(error => {
          console.error(error.message);
          alert('Failed to schedule ping request');
        });












    }


  };






  const handleRunMaintenance = (data) => {
    setHeading('Maintenance')
    setIsOpen(true)



  };



  // Filter function for both PDU and AV data
  const filteredPduData = pduData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(SearchTerm.toLowerCase())
    )
  );

  const filteredAvData = avData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(SearchTerm.toLowerCase())
    )
  );
  const [Firmware, setFirmware] = useState(null);
  const [openFirmware, setOpenFirmware] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const HandleFirmawareUpdate = (event) => {
    setFirmware(event);
    setInputValue(event.Firmware|| event.FirmwareVersion || event.firmware_version );
    
    
    
    // Ensure input value is set properly
    setOpenFirmware(true);
  
  };

  const handleSubmit =  async (e) => {

    // confirm are you sure you want to submit
   
    e.preventDefault();
   
    if (!inputValue.trim()) return; // Prevent submitting empty input
    // console.log("New Firmware Version:", inputValue);
    setConfirmSavwe(true);
    // Simulate firmware update
   
    
  
  };


  const handleFirmwareUpdate = async () => {
    setFirmware((prev) => ({ ...prev, firmware_version: inputValue }));
   



    
    try {
      const body = {
        queryType: 'custom-query',
        table: 'FirmwareUpdate',
        data: {
          query : `SELECT * FROM FirmwareUpdate WHERE device_id = '${Firmware?.id || Firmware?.ControllerId}' AND device_ip = '${Firmware?.NetworkSettings?.IPAddress || Firmware?.ip_address}'`

        }
      }

      console.log(body);
      const response = await apiMiddleware('POST', body);

      console.log(response.data)
      if (response.data.length > 0)  {

       
        const body = {
          queryType: 'custom-query',
          table: 'FirmwareUpdate',
          data: {
            query : `UPDATE FirmwareUpdate SET Firmware = '${inputValue}' WHERE device_id = '${Firmware?.id || Firmware?.ControllerId}' AND device_ip = '${Firmware?.NetworkSettings?.IPAddress || Firmware?.ip_address}'`
  
          }
        }
        const response = await apiMiddleware('POST', body);

        if (response.success) {
          console.log("Data Updated",response.data)
        }
       
      }else{
       
        const formattedDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
        const body = {
          queryType: 'custom-query',
          table: 'FirmwareUpdate',
          data: {
            query : `
            INSERT INTO FirmwareUpdate(device_id, device_ip, Firmware, device_type, created_at, updated_at, updated_by) VALUES ('${Firmware?.id || Firmware?.ControllerId}','${Firmware?.NetworkSettings?.IPAddress || Firmware?.ip_address}','${inputValue}','${selecteFilter}','${formattedDate}','${formattedDate}','Admin')
            `
            
  
          }
        }

        const response = await apiMiddleware('POST', body);
        if (response.success) {
          console.log("Data Created",response.data)
        }
      }
      
    
      handleCrudOperation();
   
    } catch (error) {
      
      console.error('Error fetching data:', error);
    }





    setOpenFirmware(false);
    setConfirmSavwe(false)
  }

  const [Confirm,setConfirm] =useState(false)


  return (


    <>

      <Helmet>
        <title>Settings</title>
      </Helmet>

      <section className="bg-SoftBlack h-auto md:mt-0 mt-16">
        <MaintenancePopup heading={Heading} SheduledProcessDateTime={SheduledProcessDateTime} isOpen={isOpen} onClose={() => setIsOpen(false)} />
        {
          loading && <Loader />
        }

<ConfirmDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={handleDownload}
        title="Confirm Download"
        message="Are you sure you want to download this file?"
      />

<ConfirmDialog
        isOpen={ConfirmSavwe}
        onClose={() => setConfirmSavwe(false)}
        onConfirm={handleFirmwareUpdate}
        title="Confirm Update"
        message="Are you sure you want to Update Version?"
      />



        {showAlert && (
          <Alert
            type={AlertData[0]?.type} // or "info" based on your needs
            title={AlertData[0]?.title}
            message={AlertData[0]?.message}
            onCloseAlert={() => setShowAlert(false)}
          />
        )}
        <Header selectedRows={selectedRows || null} HideALLBTNS={true} handleRunSelfDiagnostics={handleRunSelfDiagnostics} handleRunMaintenance={handleRunMaintenance} onButtonClick={handleonDeviceSelect} onSearchChange={handleSearchChange} HeaderBTNCLICK={FunctionBTN} />





        {/* <div className=' absolute z-[9999]  w-96 h-96 bg-white'> */}


        {
          openFirmware && (
            <div className="fixed z-50 inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">

              <div className={ `rounded-lg shadow-lg bg-SoftBlack  text-white max-w-sm text-center`}>
                <div className="flex justify-end mb-1 p-2">

                  <button onClick={() => setOpenFirmware(false)} className="w-6 h-6">
                    <img src="/Icons/close.svg" alt="close" title="close" />
                  </button>
                </div>
                <form onSubmit={handleSubmit} className="flex p-10 flex-col gap-3">
                  <label>Update Firmware For Device {Firmware.ControllerName || Firmware.model}</label>
                  <label>Current Firmware {Firmware.firmware_version || Firmware.FirmwareVersion}</label>

                  <div className='p-1 mt-2'>
                    <label>Enter New Firmware</label>
                    <input
                      type="text"
                      placeholder="Enter New Firmware"
                      className="p-2 border border-gray-500 bg-gray-700 rounded"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                    />
                  </div>
                  <button type="submit" className="bg-red-600 px-4 py-2 rounded">
                    Add
                  </button>
                </form>
              </div>
            </div>
          )
        }


        {/* Handling the filter logic before rendering */}
        {selecteFilter === 'av' && (



          <>

            <TableView handleOpenModal={HandleFirmawareUpdate} SHOWSETTINGTAB={true} headers={AVheader} SHOWSETTINGTAB7={true} rows={filteredAvData} onRowSelectionChange={handleRowSelectionChange} />
          </>
        )}
        {selecteFilter === 'pdu' && (
          <>


            <TableView handleOpenModal={HandleFirmawareUpdate} SHOWSETTINGTAB={true} headers={PDUheader} SHOWSETTINGTAB7={true} rows={filteredPduData} onRowSelectionChange={handleRowSelectionChange} />
          </>
        )}
        {selecteFilter === 'network' && (

          <>

            <TableView handleOpenModal={HandleFirmawareUpdate} SHOWSETTINGTAB={true} DataAvailabe={false} headers={PDUheader} SHOWSETTINGTAB7={true} rows={filteredPduData} onRowSelectionChange={handleRowSelectionChange} />
          </>


        )}



      </section>
    </>




  );
}

export default Devices;